module.exports = __webpack_public_path__ + "house-classic.f29dfa384c0efd7b5263.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/house-classic.svg
// module id = ../../../../../src/assets/img/house-classic.svg
// module chunks = main